<template>
  <div>
    <div class="search-con search-con-top">
      <Input clearable placeholder="输入关键字搜索" class="search-input" v-model="param.roleName"/>
      <Button @click="searchInfo()" class="search-btn" v-if="this.$getMenuAuthority('sys:role:info')" type="primary"><Icon type="search"/>&nbsp;&nbsp;搜索</Button>
      <Button @click="editInfo(false)" v-if="this.$getMenuAuthority('sys:role:save')" class="search-btn" type="primary"><Icon type="search"/>&nbsp;&nbsp;新增</Button>
    </div>
    <Table border :columns="columns1" :data="showData.list"></Table>
    <div class="page-con">
      <Page show-total :total="showData.total" :page-size="10" @on-change="chagepage" :current="showData.pageNum" show-elevator class="pull-right" />
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      showDeletewin: false,  //显示删除提示
      param: {              //查询条件
        roleName: '',
      },
      showData: {           //列表容器
        pageNum: 1
      },
      columns1: [           //表头
        {title: '角色id',key: 'roleId'},
        {title: '角色名称',key: 'roleName'},
        {title: '备注',key: 'remark'},
        {          title: '创建时间', align: 'center', key: 'createTime',
          render: (h, params) => {
            return h('div', this.$formatTimeCN(params.row.createTime, 'all'))
          }
        },
        {title: '操作',key: 'action',width: 150,align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {type: 'primary',size: 'small'},
                style: {marginRight: '5px',display: this.$getMenuAuthority('sys:role:update') ? 'inline-block' : 'none'},
                on: {
                  click: () => {
                    this.editInfo(params.row.roleId)
                  }
                }
              }, '编辑'),
              h('Button', {
                props: {type: 'error',size: 'small'},
                style: {marginRight: '5px',display: this.$getMenuAuthority('sys:role:delete') ? 'inline-block' : 'none'},
                on: {
                  click: () => {
                    this.deleteInfo(params.row.roleId)
                  }
                }
              }, '删除')
            ])
          }
        }
      ]
    }
  },
  activated() {
    this.getList ()
  },
  mounted () {
    this.getList ()
  },
  methods: {
    searchInfo() {
      this.showData.pageNum = 1
      this.getList()
    },
    chagepage (current) {
      this.showData.pageNum = current
      this.getList()
    },
    getList () {   //获取列表
      this.$Loading.start()
      this.$axios.get('/sys/role/list/' + this.showData.pageNum + '?roleName=' + this.param.roleName)
      .then(function (response) {
        if (response.data.success) {
          this.showData = response.data.data
          this.$Loading.finish()
        } else {
          this.$Message.error(response.data.errMsg)
          this.$Loading.error()
        }
      }.bind(this))
    },
    editInfo (id) {
      this.$router.push({path:'/role/edit',query:{id:id}})
    },
    deleteInfo (id) {
      this.$Modal.confirm({
        title: '删除',
        content: '<p>您确定要删除吗</p>',
        onOk: () => {
            this.$Loading.start()
            let tempfrom = [id]
            this.$axios.post('/sys/role/delete', tempfrom)
            .then(function (response) {
                if (response.data.success) {
                  this.getList()
                  this.$Message.success(response.data.errMsg)
                  this.$Loading.finish()
                } else {
                  this.$Message.error(response.data.errMsg)
                  this.$Loading.error()
                }
            }.bind(this))
        },
        onCancel: () => {
          this.$Message.warning('已取消删除')
        }
      });
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/views/role/list.vue